import "./invoice.scss";

import { Outlet } from "react-router-dom";

import { FilterInvoiceProvider } from "./filter-invoice/filter-invoice.context";

export function Invoice() {
  return (
    <div id="ShellInvoice" className="invoice">
      <FilterInvoiceProvider>
        <Outlet />
      </FilterInvoiceProvider>
    </div>
  );
}

export default Invoice;
